import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/api";

export default function DuelJoinPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    api.post("/duel/invite/join", { code })
      .then(({ data }) => navigate(`/duel/room/${data.room_id}`, { replace: true }))
      .catch((e) => {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Invalid or expired invite code");
        navigate("/duel", { replace: true });
      });
  }, [code, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="duel-join-loading">
      <div className="w-10 h-10 border-2 border-accent border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
